<template>
	<div class="route-info-content">
		<el-dialog
			title="基本信息"
			v-if="dialogVisible"
			:visible.sync="dialogVisible"
			:close-on-click-modal="false"
			:close-on-press-escape="false"
			:modal-append-to-body="false"
			:modal="false"
			custom-class="route-info-dialog"
			width="820px"
			:before-close="beforeDialogClose"
			ref="dialog"
			:top="top"
		>
			<span slot="title" class="flex flex-middle">
				<div class="title">{{ routeName }}(编辑中)：基本信息</div>
			</span>
            <div class="info">
                <span class="mr30">
					<span class="color999">销售据点分类：</span>
					<span class="color606266">{{ routeTag1 }}</span>
				</span>
				<span class="mr30">
					<span class="color999">类型：</span>
					<el-select
						size="small"
						class="w100"
						v-model="routeType"
						placeholder="请选择"
						@change="changeRouteType"
					>
						<el-option v-for="(v,k,i) in routeTypes" :label="v" :value="k" :key="i"></el-option>
					</el-select>
				</span>
            </div>
            <div class="info flex">
                <div class="flex1">
					<span class="mr30">
						<span class="color999">店铺数：</span>
						<span class="color606266">{{ buffAgentNum }}</span>
					</span>
					<span class="mr30">
						<span class="color999">上月销售：</span>
						<span class="color606266">{{ buffSumNum }}</span>
					</span>
					<span>
						<span class="color999">上月日均：</span>
						<span class="color606266">{{ buffDayAver }}</span>
					</span>
				</div>
				<div class="flex1">
					<span class="ml10 mr30">
						<span class="color999">店铺数：</span>
						<span class="color606266">{{ agentNum }}</span>
					</span>
					<span class="mr30">
						<span class="color999">上月销售：</span>
						<span class="color606266">{{ sumNum }}</span>
					</span>
					<span>
						<span class="color999">上月日均：</span>
						<span class="color606266">{{ dayAver }}</span>
					</span>
				</div>
            </div>
			<div class="flex">
				<div class="flex-1">
                    <p class="agent-info">客商及销售日均/累计信息</p>
					<el-table
						border
						:height="tableHeight"
						:data="agents"
						:header-cell-style="{
							background: 'rgba(200, 204, 215,.6)',
							color: '#333333'
						}"
						:row-class-name="rowClassName"
					>
						<el-table-column align="center" label="No" type="index" width="44">
							<template slot-scope="scope">
								{{ scope.$index + 1 == agents.length || agents.length == 0 ? '' : scope.$index + 1 }}
							</template>
						</el-table-column>
						<el-table-column prop="agentName" label="客商简称" :show-overflow-tooltip="true">
						</el-table-column>
						<el-table-column prop="channelName" width="60" label="渠道" :show-overflow-tooltip="true">
						</el-table-column>
						<el-table-column prop="allSku" width="60" label="累计" :show-overflow-tooltip="true">
						</el-table-column>
						<el-table-column prop="allDaver" width="60" label="日均" :show-overflow-tooltip="true">
						</el-table-column>
					</el-table>
				</div>
				<div class="flex-1">
                    <p class="agent-info">原路线信息</p>
					<el-table
						border
						:height="tableHeight"
						:data="agentOlds"
						:header-cell-style="{
							background: 'rgba(200, 204, 215,.6)',
							color: '#333333'
						}"
						:row-class-name="rowClassName"
					>
						<el-table-column align="center" label="No" type="index" width="44">
							<template slot-scope="scope">
								{{ scope.$index + 1 == agentOlds.length || agentOlds.length == 0 ? '' : scope.$index + 1 }}
							</template>
						</el-table-column>
						<el-table-column prop="agentName" label="客商简称" :show-overflow-tooltip="true">
						</el-table-column>
						<el-table-column prop="channelName" width="60" label="渠道" :show-overflow-tooltip="true">
						</el-table-column>
						<el-table-column prop="allSku" width="60" label="累计" :show-overflow-tooltip="true">
						</el-table-column>
						<el-table-column prop="allDaver" width="60" label="日均" :show-overflow-tooltip="true">
						</el-table-column>
					</el-table>
				</div>
			</div>
		</el-dialog>
	</div>
</template>
<script>
export default {
	data() {
		return {
			dialogVisible: false,
            // 类型
            routeTypes: {
				0: 'Min',
				1: '单人',
				2: '双人'
            },
			routeType: 0,
            // 销售据点分类
            routeTag1: '',
            // 店铺数 buff左边 原路线右边
            agentNum: 0,
            buffAgentNum: 0,
            // 上月销售
            sumNum: 0,
            buffSumNum: 0,
            // 上月日均
            dayAver: 0,
            buffDayAver: 0,
			// 当前路线
			route: null,
			// 路线名称
			routeName: '',
			// 当前列表
			agents: [],
			// 老列表
			agentOlds: [],
			route: {
				routeName: ''
			},
			// 离顶位置
			top: '117px',
			// 表格高度
			tableHeight: 798
		};
	},
	methods: {
		rowClassName({ row, column, rowIndex, columnIndex }) {
			if (row.agentName == '合计：') {
				return 'fixed-row'
			}
		},
		init(route) {
			this.dialogVisible = true;
			this.$nextTick(() => {
				this.top = window.innerWidth > 1730 ? '98px' : '138px';
				this.tableHeight = window.innerWidth > 1730 ? window.innerHeight - 292 : window.innerHeight - 332;
				this.route = route;
				this.routeName = route.routeName;
				this.agents = [];
				this.agentOlds = [];
				this.$request
					.post("routeMapInfo", true, {
						routeId: route.routeId
					})
					.then(res => {
						// 现路线信息
						if(res.data.agents) {
							let allSku = 0;
							let allDaver = 0;
							for (let index = 0; index < res.data.agents.length; index++) {
								const element = res.data.agents[index];
								allSku += element.allSku;
								allDaver += element.allDaver;
							}
							res.data.agents.push({
								agentName: '合计：',
								channelName: '',
								allSku: allSku,
								allDaver: allDaver
							})
						}
						this.agents = res.data.agents;
                        // 原路线信息
						if(res.data.agentOlds) {
							let allSkuOld = 0;
							let allDaverOld = 0;
							for (let index = 0; index < res.data.agentOlds.length; index++) {
								const element = res.data.agentOlds[index];
								allSkuOld += element.allSku;
								allDaverOld += element.allDaver;
							}
							res.data.agentOlds.push({
								agentName: '合计：',
								channelName: '',
								allSku: allSkuOld,
								allDaver: allDaverOld
							})
						}
						this.agentOlds = res.data.agentOlds;
						// 类型
                        this.routeType = res.data.routeType + '';
                        // 销售据点分类
                        this.routeTag1 = res.data.routeTag1;
                        // 店铺数
                        this.agentNum = res.data.agentNum;
                        this.buffAgentNum = res.data.buffAgentNum;
                        // 上月销售
                        this.sumNum = res.data.sumNum;
                        this.buffSumNum = res.data.buffSumNum;
                        // 上月日均
                        this.dayAver = res.data.dayAver;
                        this.buffDayAver = res.data.buffDayAver;
					});
			});
		},
		beforeDialogClose(done) {
			this.$refs.dialog.$el.classList.add('dialog-close-animation');
			setTimeout(() => {
				// 动画完成后调用 done 函数关闭对话框
				done();
			}, 700);
		},
		// 关闭
		handleClose() {
			this.dialogVisible = false;
		},
		// 变更routetype
		changeRouteType() {
			this.$request
				.post("setRouteType", true, {
					routeId: this.route.routeId,
					routeType: this.routeType
				})
				.then(res => {
					if(res.code == '0') {
						this.$emit('changeRouteType',this.route.routeId,this.routeType);
						this.$message({
							type: "success",
							message: "路线类型变更成功！"
						});
					}
				});
		}
	}
};
</script>
<style lang="scss" scoped>
.route-info-content /deep/ .el-dialog__body {
	padding: 0 5px 20px;
}

.route-info-content /deep/ .el-table .cell,
.route-info-content /deep/ .el-table .el-table__cell,
.route-info-content /deep/ .el-table th.el-table__cell > .cell {
	padding: 1px 5px;
}

.flex-1{
    width: 400px;
    padding: 10px;
    box-sizing: border-box;
}

.agent-info{
	color: #000;
	font-weight: bold;
	margin-bottom: 3px;
}

.info{
	padding: 5px 10px;
	box-sizing: border-box;
}

.mr30 {
	margin-right: 30px;
}

.mr60 {
	margin-right: 60px;
}

.w100{
	width: 100px;
}
</style>
<style>
.route-info-dialog{
	position: absolute;
	right: 0;
	animation: anim-open .8s ease !important;
}
@keyframes anim-open {
    0% {
        right: -820px;
    }

    100% {
        right: 0;
    }
}
.dialog-close-animation{
	animation: anim-close .8s ease !important;
}
@keyframes anim-close {
    0% {
        right: 0;
    }

    100% {
        right: -820px;
    }
}

.el-table__body .fixed-row {
	position: sticky;
	bottom: 0;
	width: 100%;
	height: 28px;
}
@-moz-document url-prefix() {
	.el-table__body .fixed-row {
		position: -moz-sticky;
		bottom: 0;
		width: 100%;
		height: 28px;
	}
}
/* 去除遮罩层，可点击下层元素 */
.el-dialog__wrapper{
    pointer-events: none;
}
.el-dialog{
    pointer-events: auto;
}
.flex1 {
	flex: 1;
}
.ml10 {
	margin-left: 10px;
}
</style>
